var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 4.07885C13.9124 4.23242 14.0555 4.57465 13.9801 4.9037L12.8538 9.8182H17.3333C17.5977 9.8182 17.8371 9.98863 17.9436 10.2526C18.05 10.5166 18.0034 10.8243 17.8248 11.0369L10.4914 19.7641C10.2757 20.0209 9.92344 20.0747 9.65134 19.8926C9.37924 19.7104 9.26369 19.3434 9.37578 19.0173L11.038 14.1818H6.66667C6.408 14.1818 6.17267 14.0186 6.06295 13.763C5.95323 13.5075 5.98893 13.2057 6.15453 12.989L12.8212 4.26172C13.0202 4.00116 13.3579 3.92529 13.6352 4.07885ZM8.09003 12.7273H12C12.2186 12.7273 12.4234 12.8442 12.5479 13.0403C12.6725 13.2364 12.701 13.4866 12.6242 13.7099L11.831 16.0174L15.8178 11.2727H12C11.7947 11.2727 11.6009 11.1696 11.4745 10.993C11.3482 10.8165 11.3034 10.5863 11.3532 10.3691L11.9797 7.63533L8.09003 12.7273Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.95b308f8d7873f6ec7452ff2ebbabd03.svg";
export { ForwardRef as ReactComponent };